import { render, staticRenderFns } from "./CommerceBranchesSelect.vue?vue&type=template&id=6cbf0e66&"
import script from "./CommerceBranchesSelect.vue?vue&type=script&lang=ts&"
export * from "./CommerceBranchesSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports